var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"version"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"bg"}),_c('div',{staticClass:"t1"},[_c('img',{attrs:{"src":require("_img/common/c.png"),"alt":""}}),_c('span',[_vm._v("当前版本: V1.5")])]),_c('div',{staticClass:"t2"},[_c('i'),_c('span',[_vm._v("最新版本: V1.5")])])])])
}]

export { render, staticRenderFns }